module.exports = __webpack_public_path__ + "img/pl.67193671.svg";